export enum AccountingType {
  Bank = 'bank',
  Card = 'card',
  Cash = 'cash',
  CrmInvoices = 'crmInvoices',
  Other = 'other',
  PaymentFees = 'paymentFees',
  SecretSpaFees = 'secretSpaFees',
  SecretSpaPayments = 'secretSpaPayments',
  SoloPayments = 'soloPayments',
  SoloReferrals = 'soloReferrals',
  SoloRefunds = 'soloRefunds',
  SubscriptionsPaid = 'subscriptionsPaid'
}

export enum ActivityStatus {
  Hidden = 'hidden',
  Interacted = 'interacted',
  Read = 'read',
  Unread = 'unread'
}

export enum AddonType {
  SalonMemberSeat = 'salonMemberSeat'
}

export enum AdvancePaymentOptionId {
  FullDeposit = 'FULL_DEPOSIT',
  No = 'NO',
  PartialDeposit = 'PARTIAL_DEPOSIT'
}

export enum AuthRole {
  Admin = 'ADMIN',
  BookingPortal = 'BOOKING_PORTAL',
  Client = 'CLIENT',
  CompleteAccountWithMobile = 'COMPLETE_ACCOUNT_WITH_MOBILE',
  Guest = 'GUEST',
  PreRegistration = 'PRE_REGISTRATION',
  PreRegistrationSalonMember = 'PRE_REGISTRATION_SALON_MEMBER',
  PreRegistrationSolo = 'PRE_REGISTRATION_SOLO',
  Professional = 'PROFESSIONAL',
  Saas = 'SAAS',
  Salon = 'SALON',
  SalonAdmin = 'SALON_ADMIN',
  SalonReceptionist = 'SALON_RECEPTIONIST',
  SendMobileVerification = 'SEND_MOBILE_VERIFICATION',
  SignInWithMobile = 'SIGN_IN_WITH_MOBILE',
  Tech = 'TECH',
  Upload = 'UPLOAD'
}

export enum AutoAcceptBookingRequestOption {
  All = 'ALL',
  Off = 'OFF',
  RepeatClientsOnly = 'REPEAT_CLIENTS_ONLY'
}

export enum AutomatedTriggerType {
  ClientReferralAlmost = 'clientReferralAlmost',
  ClientReferralCompleted = 'clientReferralCompleted',
  ClientReferralHalf = 'clientReferralHalf',
  FirstBooking = 'firstBooking',
  GcPaymentReceipt = 'gc_paymentReceipt',
  GcRedemptionCode = 'gc_redemptionCode',
  Lapsed = 'lapsed',
  LoyaltyAlmost = 'loyaltyAlmost',
  LoyaltyCompleted = 'loyaltyCompleted',
  LoyaltyHalf = 'loyaltyHalf',
  OfflineBooking = 'offlineBooking',
  TrBookingAccepted = 'tr_bookingAccepted',
  TrBookingCancellationRequested = 'tr_bookingCancellationRequested',
  TrBookingCancelled = 'tr_bookingCancelled',
  TrBookingCompleted = 'tr_bookingCompleted',
  TrBookingConsultationFormReminder = 'tr_bookingConsultationFormReminder',
  TrBookingDeclined = 'tr_bookingDeclined',
  TrBookingDepositReminder = 'tr_bookingDepositReminder',
  TrBookingNoShow = 'tr_bookingNoShow',
  TrBookingReminder = 'tr_bookingReminder',
  TrBookingRequested = 'tr_bookingRequested',
  TrBookingUpdated = 'tr_bookingUpdated',
  TrPaymentReceipt = 'tr_paymentReceipt',
  TrRescheduleRejected = 'tr_rescheduleRejected',
  TrReviewReminder = 'tr_reviewReminder',
  UpcomingBirthday = 'upcomingBirthday'
}

export enum BaseCampaignTemplateType {
  Blank = 'blank',
  ClientReferralScheme = 'clientReferralScheme',
  GiftCard = 'giftCard',
  LoyaltyScheme = 'loyaltyScheme',
  NewTreatments = 'newTreatments',
  RunPromotion = 'runPromotion',
  UpcomingAvailability = 'upcomingAvailability',
  WebsiteLaunch = 'websiteLaunch'
}

export enum CrmMessageType {
  Accepted = 'accepted',
  Automated = 'automated',
  Broadcast = 'broadcast',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Consultation = 'consultation',
  Reminder = 'reminder',
  Updated = 'updated'
}

export enum CampaignMessageType {
  Email = 'email',
  Sms = 'sms'
}

export enum CampaignStatus {
  Active = 'active',
  Archived = 'archived',
  Draft = 'draft',
  Paused = 'paused',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent'
}

export enum CampaignType {
  Automated = 'automated',
  Broadcast = 'broadcast'
}

export enum CancellationReason {
  Cancelled = 'cancelled',
  NoShow = 'noShow'
}

export enum CheckoutMode {
  Payment = 'payment',
  Subscription = 'subscription'
}

export enum CompletePaymentMethodOptionId {
  Bank = 'bank',
  Cash = 'cash',
  GiftCard = 'gift_card',
  Machine = 'machine',
  Other = 'other',
  QrCode = 'qrCode',
  SavedCard = 'savedCard',
  Stripe = 'stripe',
  TapToPay = 'tapToPay'
}

export enum ConsultationFormStatus {
  Completed = 'COMPLETED',
  NotRequired = 'NOT_REQUIRED',
  ReminderSent = 'REMINDER_SENT',
  Requested = 'REQUESTED'
}

export enum ContactType {
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Phone = 'PHONE',
  Tiktok = 'TIKTOK'
}

export enum CrmUsageType {
  Email = 'email',
  Sms = 'sms'
}

export enum DashboardBookingFilter {
  BookingRequests = 'BOOKING_REQUESTS',
  CancelRequests = 'CANCEL_REQUESTS',
  ConsultationFormRequired = 'CONSULTATION_FORM_REQUIRED',
  DepositNotPaid = 'DEPOSIT_NOT_PAID',
  PaymentOutstanding = 'PAYMENT_OUTSTANDING',
  RescheduleRequests = 'RESCHEDULE_REQUESTS',
  Today = 'TODAY',
  ToComplete = 'TO_COMPLETE'
}

export enum DeletableModelNames {
  ConsultationForm = 'ConsultationForm',
  ExternalPromoCode = 'ExternalPromoCode',
  ExternalReview = 'ExternalReview',
  ExternalTreatment = 'ExternalTreatment',
  ProfessionalAvailability = 'ProfessionalAvailability',
  Review = 'Review'
}

export enum DiaryEventWarningStatus {
  Bad = 'bad',
  None = 'none',
  Warn = 'warn'
}

export enum DiarySegmentType {
  Buffer = 'BUFFER',
  Processing = 'PROCESSING',
  Service = 'SERVICE',
  Treatment = 'TREATMENT'
}

export enum DiscountType {
  Monies = 'monies',
  Percent = 'percent'
}

export enum EmailContentBlockType {
  AftercareButton = 'aftercareButton',
  BoldText = 'boldText',
  BookingDateAndLocation = 'bookingDateAndLocation',
  BookingItems = 'bookingItems',
  Button = 'button',
  CancellationPolicy = 'cancellationPolicy',
  ClientReferralScheme = 'clientReferralScheme',
  Ctas = 'ctas',
  DeclineReason = 'declineReason',
  GiftCardDetails = 'giftCardDetails',
  GiftCardReceipt = 'giftCardReceipt',
  HeaderImage = 'headerImage',
  HorizontalLine = 'horizontalLine',
  Image = 'image',
  LoyaltyScheme = 'loyaltyScheme',
  Promocode = 'promocode',
  SocialLinks = 'socialLinks',
  Text = 'text',
  Title = 'title'
}

export enum ExternalBookingPaymentStatus {
  DepositNotPaid = 'DEPOSIT_NOT_PAID',
  DepositPaid = 'DEPOSIT_PAID',
  FullyPaid = 'FULLY_PAID',
  NoDepositNotPaid = 'NO_DEPOSIT_NOT_PAID',
  NoDepositPartiallyPaid = 'NO_DEPOSIT_PARTIALLY_PAID'
}

export enum ExternalBookingSource {
  BookingPortal = 'BOOKING_PORTAL',
  Marketplace = 'MARKETPLACE',
  ProApp = 'PRO_APP'
}

export enum ExternalBookingStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  CancelRequested = 'CANCEL_REQUESTED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Requested = 'REQUESTED',
  Reschedule = 'RESCHEDULE',
  ToComplete = 'TO_COMPLETE'
}

export enum ExternalClientGroups {
  FrequentClients = 'frequentClients',
  NewClients = 'newClients',
  NoBookingLast30 = 'noBookingLast30',
  TopSpenders = 'topSpenders',
  UpcomingBirthday = 'upcomingBirthday'
}

export enum ExternalPaymentStatus {
  Cleared = 'CLEARED',
  Processing = 'PROCESSING'
}

export enum FooterAddressVisibilityOption {
  Area = 'AREA',
  Full = 'FULL',
  Hidden = 'HIDDEN'
}

export enum GeoJsonPointType {
  Point = 'Point'
}

export enum GiftCardStatus {
  Active = 'active',
  Expired = 'expired',
  Used = 'used'
}

export enum GiftCardTransactionType {
  Manual = 'manual',
  Payment = 'payment',
  Refund = 'refund',
  StripePayment = 'stripe_payment',
  StripeRefund = 'stripe_refund'
}

export enum IncomeStatType {
  All = 'all',
  Solo = 'solo'
}

export enum LoyaltySchemeGoalType {
  Booking = 'booking',
  Spend = 'spend'
}

export enum LoyaltySchemeLogType {
  BookingCompleted = 'bookingCompleted',
  CurrentManualChange = 'currentManualChange',
  GoalChange = 'goalChange',
  GoalNumberChange = 'goalNumberChange',
  SchemeCompleted = 'schemeCompleted'
}

export enum LoyaltySchemeStatus {
  Active = 'active',
  Draft = 'draft'
}

export enum LoyaltySchemeUsageType {
  ClientReferral = 'clientReferral',
  Default = 'default'
}

export enum MarketplaceContactDetailType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Website = 'WEBSITE'
}

export enum MarketplaceTagCategory {
  Brand = 'Brand',
  Certification = 'Certification',
  Location = 'Location',
  Price = 'Price',
  Service = 'Service',
  Treatment = 'Treatment',
  Verification = 'Verification'
}

export enum MessageType {
  Modal = 'MODAL'
}

export enum PaymentMethodOptionId {
  ManualCollection = 'MANUAL_COLLECTION',
  PaymentLink = 'PAYMENT_LINK'
}

export enum PaymentTypes {
  Bank = 'bank',
  Cash = 'cash',
  GiftCard = 'gift_card',
  GiftCardRefund = 'gift_card_refund',
  Machine = 'machine',
  Other = 'other',
  Stripe = 'stripe',
  StripeRefund = 'stripe_refund'
}

export enum PeriodUnit {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export enum PlanPeriodUnit {
  Month = 'month',
  Year = 'year'
}

export enum PlanType {
  Elite = 'elite',
  Grow = 'grow',
  Pro = 'pro',
  Starter = 'starter',
  Unknown = 'unknown',
  Website = 'website'
}

export enum Platform {
  Ca = 'CA',
  Pa = 'PA',
  Wb = 'WB'
}

export enum QuestionType {
  Image = 'IMAGE',
  LongText = 'LONG_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Text = 'TEXT',
  YesOrNo = 'YES_OR_NO'
}

export enum RedeemableBy {
  Anyone = 'anyone',
  Custom = 'custom',
  ExistingClients = 'existingClients',
  NewClients = 'newClients'
}

export enum ReviewReplyTone {
  Friendly = 'FRIENDLY',
  Grateful = 'GRATEFUL',
  Professional = 'PROFESSIONAL',
  Warm = 'WARM'
}

export enum SaasPaymentMethodType {
  BankTransfer = 'bankTransfer',
  CardTerminal = 'cardTerminal',
  Cash = 'cash',
  Custom = 'custom',
  GiftCard = 'giftCard',
  Link = 'link',
  SavedCard = 'savedCard'
}

export enum SalonMemberOnboardingStep {
  Details = 'DETAILS',
  Permissions = 'PERMISSIONS',
  Schedules = 'SCHEDULES',
  Treatments = 'TREATMENTS'
}

export enum SalonMemberPermission {
  Admin = 'ADMIN',
  CheckoutAndPayments = 'CHECKOUT_AND_PAYMENTS',
  CreateAndUpdateBookings = 'CREATE_AND_UPDATE_BOOKINGS',
  Owner = 'OWNER',
  Receptionist = 'RECEPTIONIST',
  ServiceProvider = 'SERVICE_PROVIDER',
  ViewClientDetails = 'VIEW_CLIENT_DETAILS',
  ViewOtherMemberCalendars = 'VIEW_OTHER_MEMBER_CALENDARS'
}

export enum SalonMemberStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Invited = 'INVITED'
}

export enum ScheduleEntryType {
  Processing = 'PROCESSING',
  Treatment = 'TREATMENT'
}

export enum ScheduledCampaignStatus {
  Cancelled = 'cancelled',
  Draft = 'draft',
  Scheduled = 'scheduled',
  Sent = 'sent'
}

export enum SoloReferralAction {
  NewPortalRequest = 'NEW_PORTAL_REQUEST',
  SignUp = 'SIGN_UP',
  Subscribe = 'SUBSCRIBE',
  Trial = 'TRIAL'
}

export enum SoloReferralRewardStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum SoloReferralRewardType {
  Subscription = 'SUBSCRIPTION'
}

export enum SoloReferralStatus {
  ReceivedBooking = 'RECEIVED_BOOKING',
  SignedUp = 'SIGNED_UP',
  Subscribed = 'SUBSCRIBED',
  Trial = 'TRIAL'
}

export enum SoloSubscriptionAction {
  Cancel = 'cancel',
  ScheduleCancel = 'scheduleCancel',
  StartTrial = 'startTrial',
  Subscribe = 'subscribe'
}

export enum SoloSubscriptionPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export enum SpecialQuestions {
  Comments = 'comments'
}

export enum StripeAccountStatus {
  Completed = 'COMPLETED',
  Errors = 'ERRORS',
  NotSubmitted = 'NOT_SUBMITTED',
  Pending = 'PENDING',
  Restricted = 'RESTRICTED'
}

export enum StripePaymentTypes {
  Link = 'link',
  SavedCard = 'saved_card',
  TapToPay = 'tap_to_pay'
}

export enum StripeTransactionType {
  Fee = 'fee',
  Payment = 'payment',
  Payout = 'payout',
  Referral = 'referral',
  Refund = 'refund',
  SsPayout = 'ss_payout'
}

export enum SupportedCountry {
  Au = 'AU',
  Es = 'ES',
  Gb = 'GB',
  Ie = 'IE'
}

export enum SupportedCurrency {
  Aud = 'aud',
  Eur = 'eur',
  Gbp = 'gbp'
}

export enum UpfrontPaymentClientType {
  Existing = 'existing',
  New = 'new'
}

export enum UpfrontPaymentOption {
  Approval = 'approval',
  Checkout = 'checkout',
  None = 'none',
  SaveCard = 'save_card'
}

export enum WebPageBlockButtonType {
  BookNow = 'BookNow',
  Custom = 'Custom',
  Email = 'Email',
  GiftCard = 'GiftCard',
  MyBookings = 'MyBookings',
  Page = 'Page',
  Phone = 'Phone',
  Reviews = 'Reviews'
}

export enum WebPageBlockColor {
  Dark = 'DARK',
  Light = 'LIGHT',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum WebPageBlockType {
  /** @deprecated use actionButton or button on block instead */
  Button = 'BUTTON',
  /** @deprecated use IMAGE instead */
  HomeHeader = 'HOME_HEADER',
  Image = 'IMAGE',
  ImageCollection = 'IMAGE_COLLECTION',
  Info = 'INFO',
  LinkList = 'LINK_LIST',
  Location = 'LOCATION',
  LogoList = 'LOGO_LIST',
  /** @deprecated use IMAGE_COLLECTION instead */
  Lookbook = 'LOOKBOOK',
  /** @deprecated use IMAGE instead */
  PageHeader = 'PAGE_HEADER',
  Reviews = 'REVIEWS',
  ReviewsList = 'REVIEWS_LIST',
  SalonMemberBlock = 'SALON_MEMBER_BLOCK',
  Text = 'TEXT',
  TreatmentList = 'TREATMENT_LIST'
}

export enum WebPageExternalReviewsDisplay {
  Custom = 'Custom',
  LatestTop3 = 'LatestTop3'
}

export enum WebPageTreatmentListDisplayType {
  All = 'ALL',
  Custom = 'CUSTOM'
}

export enum WebPageVisibility {
  Archived = 'ARCHIVED',
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export enum RescheduleStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

export enum RescheduleType {
  Cancel = 'cancel',
  Keep = 'keep'
}
